import React, { useState, useEffect } from "react";
import bioImg from "../images/by-my-side-homepage_seuil22.jpg";
import contactFrame from "../images/frame2.png";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

export default function Contact() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timeout);
  }, []);
  return (
    <div className={`exhibitions-fade${visible ? " fade-in" : ""}`}>
      <Link to="/" className="bio">
        <img className="bioImg" src={bioImg} alt="bioImg" />
      </Link>

      <div className="contactText">
        <img className="contactFrame" src={contactFrame} />
        <div className="contact-insideText">
          <span className="contactPicto">✉️</span>&nbsp;mglassfield@gmail.com
          <br></br>
          <span className="contactPicto">↳</span>
          <Link
            className="linkInsta"
            to="https://www.instagram.com/monaglassfi3ld/"
          >
            {" "}
            instagram<br></br>
          </Link>
        </div>
      </div>
    </div>
  );
}
